import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {OrderV2Service} from "@root/router/order-v2/order-v2.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {TranslateService} from "@root/shared/service/translate.service";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";

@Component({
  selector: 'host-widget-check-guide-menu',
  templateUrl: 'check-guide-menu.component.html',
  styleUrls: ['./check-guide-menu.component.scss']
})

export class WidgetCheckGuideMenuComponent implements OnInit {
  @Input() code;
  @Input() houseId;
  @Input() completeCheckGuideSetting = false;
  @Input() emails;
  @ViewChild('shareQRCodeTpl') shareQRCodeTpl: TemplateRef<any>;
  @ViewChild('sendEmailTpl') sendEmailTpl: TemplateRef<any>;

  checkGuideLink;

  constructor(
    private service: OrderV2Service,
    private modal: NzModalService,
    private msg: NzMessageService,
    private t: TranslateService,
    private router: Router
  ) {
  }

  ngOnInit() {
  }

  fetchCopyLink() {
    this.service.getShareUrl({ reservation_code: this.code })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.checkGuideLink = res.data && res.data.content;
        }
      });
  }

  // copyCheckinLink() {
  //   if (!this.completeCheckGuideSetting) {
  //     return this.displayEmptyCheckinGuideWarn();
  //   }
  //
  //   this.checkinLinkClipboard = new ClipboardJS('.share-copy');
  //   this.checkinLinkClipboard.on('success', () => {
  //     const successText = this.t.syncGet('success.has_copied');
  //     this.messageService.success(successText);
  //     this.checkinLinkClipboard.destroy();
  //     this.checkinLinkClipboard = null;
  //   });
  // }

  onClickShowShareQRCode() {
    if (!this.completeCheckGuideSetting) {
      return this.displayEmptyCheckinGuideWarn();
    }
    this.modal.create({
      nzTitle: null,
      nzWidth: 290,
      nzFooter: null,
      nzContent: this.shareQRCodeTpl,
    });
  }

  onClickSendEmail() {
    if (!this.completeCheckGuideSetting) {
      return this.displayEmptyCheckinGuideWarn();
    }

    this.modal.create({
      // 邮箱地址
      nzTitle: this.t.syncGet('order.email_address'),
      nzContent: this.sendEmailTpl,
      nzWidth: 398,
      nzFooter: null,
    });
  }

  private displayEmptyCheckinGuideWarn() {
    this.modal.confirm({
      nzTitle: this.t.syncGet('warning.order.sidebar.check_in_info_required'),
      nzOkText: this.t.syncGet('warning.order.sidebar.to_set_check_in_info'),
      nzOnOk: () => {
        this.router.navigate(['/app/properties/detail'], {
          queryParams: {
            id: this.houseId,
            subTab: 2,
          },
        });
      },
    });
  }

  onCancelSendEmail() {}

  onConfirmSendEmail() {
    if (this.emails === '' || this.emails === null) {
      return;
    }
    const temp = this.emails.split('\n');
    const params = {
      reservation_code: this.code,
      email: JSON.stringify(temp),
    };
    this.service.sendGuideEmail(params).subscribe((res) => {
      if (res.error_code === 0) {
        const successText = this.t.syncGet('success.submitted_to_be_sent');
        this.msg.success(successText);
      } else {
        const errorText = this.t.syncGet('warning.send_failed');
        this.msg.warning(errorText);
      }
    });
  }
}
